"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoTHealingEffectHandler = exports.HoTHealingEffectArgs = void 0;
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class HoTHealingEffectArgs {
    constructor(abilityKey, amount, attributePercent = 25) {
        this.abilityKey = abilityKey;
        this.amount = amount;
        this.attributePercent = attributePercent;
        this.__type = EffectType_1.EffectType.HoTHealing;
        this.__typeName = "HoTHealing";
        this.name = "Healing";
        this.harmful = false;
    }
}
exports.HoTHealingEffectArgs = HoTHealingEffectArgs;
let HoTHealingEffectHandler = class HoTHealingEffectHandler {
    apply(sequence, container, state) {
        if (container.isDeceased(state.targetId)) {
            return;
        }
        else if (container.getAttributeScore(state.targetId, enums_1.AttributeType.Health) >= container.getMaxAttributeScore(state.targetId, enums_1.AttributeType.Health)) {
            return;
        }
        container.applyHealing({
            sequence,
            healerId: state.creatorId,
            targetId: state.targetId,
            amount: state.args.amount,
            attributePercent: state.args.attributePercent
        });
    }
    remove(sequence, container, state) { }
};
HoTHealingEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.HoTHealing)
], HoTHealingEffectHandler);
exports.HoTHealingEffectHandler = HoTHealingEffectHandler;
